angular.module('dnecom').controller('MarketingHubController', ["$scope", "$http", "notifications", "wizardModal", function($scope, $http, notifications, wizardModal) {
    $scope.store = TemplateData.value('store');

    $scope.checkLicense = function (event) {
        if ($scope.store.marketingHubEnabled) {
            return true;
        }

        event.preventDefault();

        $http
            .post(Routing.generate('marketinghub_check_license', { store: $scope.store.id }))
            .then(
                function (response) {
                    if (response.data.success) {
                        var licenseModal = wizardModal.open({
                            templateUrl: 'marketingHubLicenseModal.html',
                            controller: 'marketingHubLicenseModalController'
                        });

                        licenseModal.result.then(function () {
                            $http
                                .post(Routing.generate('marketinghub_activate_license', { store: $scope.store.id }))
                                .then(
                                    function (response) {
                                        if (response.data.success) {
                                            notifications.success('License activated successfully.');
                                            window.location = event.delegateTarget.href;
                                        } else {
                                            notifications.danger('Failed to activate license:' + response.data.error + '. Please try again.');
                                        }
                                    },
                                    function () {
                                        notifications.danger('Failed to activate license: invalid server response. Please try again.');
                                    }
                                );
                        });
                    } else {
                        wizardModal.open({
                            templateUrl: 'licenseUpgradeModal.html',
                            controller: 'licenseUpgradeModalController',
                            size: 'md',
                            windowClass: 'modal-jumbotron',
                            'resolve': {
                                'licenseError': function () {
                                    return response.data.error;
                                },
                                'store': function () {
                                    return $scope.store;
                                }
                            }
                        });
                    }
                },
                function () {
                    notifications.danger('Failed to check license: invalid server response. Please try again.');
                }
            );

        return false;
    };
}]);
